import telIcon from '../assets/imgs/tel.png'
import timeIcon from '../assets/imgs/time.png'
import addressIcon from '../assets/imgs/address.png'
export default {
  data() {
    return {
      telIcon: telIcon,
      timeIcon: timeIcon,
      addressIcon: addressIcon,
      markerLayer: {},
      map: {},
      infoWindow: null,
      baseUrl: process.env.NODE_ENV
    }
  },
  methods: {
    goMap(item) {
      let url = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&tocoord=${item.positionY, item.positionX}&policy=1&to=${item.hallName}&ref=GOCBZ-EAW6P-AZQDK-LQBJN-KTUSF-SKFAU`
      window.open(url);
    },
    // 修改地图中心点
    changeCenter(item) {
      this.map.setCenter(new window.TMap.LatLng(item.positionY, item.positionX));
      this.$nextTick(() => {
        this.setInfoWindow(new TMap.LatLng(item.positionY, item.positionX), item)
      })
    },
    // 地图初始化函数
    initMap() {
      console.log("window", window);
      // 定义地图中心点坐标
      let center = new TMap.LatLng(this.hallList[0].positionY, this.hallList[0].positionX); //经纬度
      // 定义map变量，调用 TMap.Map() 构造函数创建地图
      let map = new TMap.Map(document.getElementById("mapContainer"), {
        center: center, // 设置地图中心点坐标
        zoom: 18, // 设置地图缩放级别
        pitch: 43.5, // 设置俯仰角
        rotation: 45, // 设置地图旋转角度
      });
      this.map = map;
      this.setImgMarker();
      this.setInfoMarker(this.hallList[0]);
    },
    // 设置展示在地图上的标注点
    setImgMarker() {
      let geometries = [];
      let geometries2 = [];
      this.hallList.forEach((item, i) => {
        geometries.push({
          id: i + 1, //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: "myStyle", //指定样式id
          position: new TMap.LatLng(item.positionY, item.positionX), //点标记坐标位置
          content: i + 1 + "", //只支持字符串
          properties: item
        })
        //文字标记 数据数组
        geometries2.push({
          id: i + 1, //点图形数据的标志信息
          styleId: 'label', //样式id
          position: new TMap.LatLng(item.positionY, item.positionX), //标注点位置
          content: item.hallName, //标注文本
        })
      })
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        //样式定义
        styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          myStyle: new TMap.MarkerStyle({
            width: 35, // 点标记样式宽度（像素）
            height: 35, // 点标记样式高度（像素）
            size: 18,
            color: "#FFFFFF",
            src: `/ApprWindowIntegration/map.png`,
            offset: {
              x: 0,
              y: -2
            }, //文字偏移属性单位为像素
            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            anchor: {
              x: 16,
              y: 35
            },
          }),
        },
        //点标记数据数组 
        geometries: geometries
      });

      //初始化label
      // var label = new TMap.MultiLabel({
      //   id: 'label-layer',
      //   map: this.map, //设置折线图层显示到哪个地图实例中
      //   //文字标记样式
      //   styles: {
      //     'label': new TMap.LabelStyle({
      //       'color': '#3E97DF', //颜色属性
      //       'size': 20, //文字大小属性
      //       'offset': {
      //         x: 0,
      //         y: 10
      //       }, //文字偏移属性单位为像素
      //       'angle': 0, //文字旋转属性
      //       'alignment': 'center', //文字水平对齐属性
      //       'verticalAlignment': 'middle' //文字垂直对齐属性
      //     })
      //   },
      //   //文字标记数据
      //   geometries: geometries2
      // });
    },
    // 点击地图上的标注点，需要展示的弹框
    setInfoMarker(item) {
      //初始化infoWindow
      this.infoWindow = new TMap.InfoWindow({
        map: this.map,
        position: new TMap.LatLng(item.positionY, item.positionX),
        offset: {
          x: 0,
          y: -40
        }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
      });
      this.setInfoWindow(new TMap.LatLng(item.positionY, item.positionX), item); //初始化默认打开第一个
      this.markerLayer.on("click", (e) => {
        this.infoWindow.close();
        console.log(this.markerLayer)
        const position = e.latLng;
        console.log("--e---", e)
        this.setInfoWindow(e.geometry.position, e.geometry.properties)
      });
    },
    // 弹框数据
    setInfoWindow(position, item) {
      this.infoWindow.close(); //关闭信息窗关闭
      //设置infoWindow
      this.infoWindow.open(); //打开信息窗
      this.infoWindow.setPosition(position); //设置信息窗位置
      this.infoWindow.setContent(`<div class="hall-item" style="width:390px;">
          <div class="hall-name"><i class="hall-index-icon">${item.num}</i>${item.hallName}</div>
          <div class="hall-item-detail flex-row">
            <img src="${telIcon}" class="hall-img" alt="大厅电话">
            <div>${item.telPhone}</div>
          </div>
          <div class="hall-item-detail flex-row">
            <img src="${timeIcon}" class="hall-img" alt="时间">
            <div>${item.workTime}</div>
          </div>
          <div class="hall-item-detail flex-row">
            <img src="${addressIcon}" class="hall-img" alt="大厅地址">
            <div>${item.address}</div>
          </div>
          <button class="hall-item-btn" id="btn">去这里 <i class="el-icon-right"></i></button>
        </div>`)
      document.getElementById("btn").onclick = (() => {
        this.goMap(item)
      })
    }
  },
}